import api from '@pray/shared/utils/api';
import { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { ApiEmailDomainResponse } from './types';

type GetArtistEmailDomainsProps = {
  artistId: string;
};

export const getArtistEmailDomains = async ({ artistId }: GetArtistEmailDomainsProps) => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/emails/domains`;

  const response = await api.executeGetRequest<ObjectResponse<ApiEmailDomainResponse>>(url);

  return response.data;
};
